export const Sidebar = {
  tag: 'aside',
  flow: 'y',
  width: 'G',
  minWidth: 'G',
  height: '100vh',
  background: 'surfaceMid',
  padding: 'B A 0 A',
  position: 'sticky',
  top: '0',
  flexShrink: '0',
  justifyContent: 'space-between',
  overflow: 'auto',
  transition: 'width 200ms, min-width 200ms, padding 200ms',

  '@tabletS': {
    width: 'C',
    minWidth: 'C',
    padding: 'B Y'
  },
  '@mobileL': {
    display: 'none'
  },

  TopSection: {
    flow: 'y',
    gap: 'C',

    LogoBrand: {
      extends: 'Link',
      href: '/dashboard',
      text: 'TrustLegal',
      fontSize: 'B',
      fontWeight: '800',
      color: 'green',
      padding: '0 A',
      textDecoration: 'none',
      '@tabletS': { fontSize: 'A', padding: '0', textAlign: 'center' }
    },

    NavItems: {
      flow: 'y',
      gap: 'Z',

      NavDashboard: {
        extends: 'SidebarNavItem',
        href: '/dashboard',
        background: (el) =>
          window.location.pathname === '/dashboard' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'dashboard',
          color: (el) =>
            window.location.pathname === '/dashboard' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarMain | polyglot }}',
          color: (el) =>
            window.location.pathname === '/dashboard' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/dashboard' ? '600' : '500'
        }
      },
      NavBookings: {
        extends: 'SidebarNavItem',
        href: '/bookings',
        background: (el) =>
          window.location.pathname === '/bookings' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'calendar',
          color: (el) =>
            window.location.pathname === '/bookings' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarBookings | polyglot }}',
          color: (el) =>
            window.location.pathname === '/bookings' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/bookings' ? '600' : '500'
        }
      },
      NavCases: {
        extends: 'SidebarNavItem',
        href: '/cases',
        background: (el) =>
          window.location.pathname === '/cases' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'briefcase',
          color: (el) =>
            window.location.pathname === '/cases' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarCases | polyglot }}',
          color: (el) =>
            window.location.pathname === '/cases' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/cases' ? '600' : '500'
        }
      },
      NavClients: {
        extends: 'SidebarNavItem',
        href: '/clients',
        background: (el) =>
          window.location.pathname === '/clients' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'user',
          color: (el) =>
            window.location.pathname === '/clients' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarClients | polyglot }}',
          color: (el) =>
            window.location.pathname === '/clients' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/clients' ? '600' : '500'
        }
      },
      NavDocs: {
        extends: 'SidebarNavItem',
        href: '/documents',
        background: (el) =>
          window.location.pathname === '/documents' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'document',
          color: (el) =>
            window.location.pathname === '/documents' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarDocs | polyglot }}',
          color: (el) =>
            window.location.pathname === '/documents' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/documents' ? '600' : '500'
        }
      },
      NavBilling: {
        extends: 'SidebarNavItem',
        href: '/billing',
        background: (el) =>
          window.location.pathname === '/billing' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'briefcase',
          color: (el) =>
            window.location.pathname === '/billing' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarPayments | polyglot }}',
          color: (el) =>
            window.location.pathname === '/billing' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/billing' ? '600' : '500'
        }
      },
      NavAI: {
        extends: 'SidebarNavItem',
        href: '/ai',
        background: (el) =>
          window.location.pathname === '/ai' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'ai',
          color: (el) =>
            window.location.pathname === '/ai' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: 'AI',
          color: (el) =>
            window.location.pathname === '/ai' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/ai' ? '600' : '500'
        }
      },
      NavSettings: {
        extends: 'SidebarNavItem',
        href: '/settings',
        background: (el) =>
          window.location.pathname === '/settings' ? 'greenBg' : 'transparent',
        NavIcon: {
          icon: 'settings',
          color: (el) =>
            window.location.pathname === '/settings' ? 'green' : 'textSoft'
        },
        NavLabel: {
          text: '{{ sidebarSettings | polyglot }}',
          color: (el) =>
            window.location.pathname === '/settings' ? 'green' : 'textSoft',
          fontWeight: (el) =>
            window.location.pathname === '/settings' ? '600' : '500'
        }
      }
    }
  },

  BottomSection: {
    flow: 'x',
    gap: 'Z',
    align: 'center',
    padding: 'A',
    borderTop: '1px solid surfaceBorderStrong',
    '@tabletS': { display: 'none' },

    AvatarCircle: {
      width: 'B',
      height: 'B',
      borderRadius: '100%',
      background: 'greenBg',
      color: 'green',
      flow: 'x',
      align: 'center center',
      fontSize: 'Z',
      fontWeight: '700',
      text: (el, s) => s.root.firm.initials,
      flexShrink: '0'
    },
    UserInfo: {
      flow: 'y',
      gap: '0',
      flex: '1',
      UserName: {
        text: (el, s) => s.root.firm.lawyer,
        fontSize: 'Z',
        fontWeight: '600',
        color: 'text'
      },
      LogoutLink: {
        extends: 'Link',
        href: '/',
        text: '{{ sidebarLogout | polyglot }}',
        fontSize: 'Y',
        color: 'textMuted',
        textDecoration: 'none',
        onClick: (e, el, s) => s.root.update({ loggedIn: false })
      }
    }
  }
}
